import { OrganizationLogo as BaseOrganizationLogo } from '@airship-platform/jam-web/components';
import { SxProps, Theme } from '@mui/material/styles';
import { useAssetContext } from './AssetContext';

interface OrganizationLogoProps {
  logoParams: {
    organizationId?: string;
    organizationLogoUrlVersion?: string | null;
    imageProps?: {
      width: number;
    };
  };
  sx?: SxProps<Theme>;
  basePublicFilesUrl?: string;
  fallbackIcon?: React.ReactNode;
}

const OrganizationLogo: React.FC<OrganizationLogoProps> = ({
  basePublicFilesUrl,
  ...props
}) => {
  const { basePublicFilesUrl: contextUrl } = useAssetContext();
  return (
    <BaseOrganizationLogo
      basePublicFilesUrl={basePublicFilesUrl || contextUrl}
      {...props}
    />
  );
};

export default OrganizationLogo;
